import axios from "axios";
import { APP_ID, TOKEN_INFO_SESSION_STORAGE_KEY } from "../constants";
import { BASE_URL } from "../environments";
import { getVariantValue } from "./variantTunnel";

export const appAxios = axios.create({
  baseURL: BASE_URL,
  headers: { "X-App-Id": APP_ID, "X-App-Version": __APP_VERSION__ },
});

appAxios.interceptors.request.use(async (config) => {
  const xBackendVariant = getVariantValue();
  const tokenInfoStr = sessionStorage.getItem(TOKEN_INFO_SESSION_STORAGE_KEY);
  const tokenInfo = JSON.parse(tokenInfoStr || "null");

  return {
    ...config,
    headers: {
      ...(tokenInfo && { Authorization: `Bearer ${tokenInfo.access_token}` }),
      ...(xBackendVariant && { "X-Backend-Variant": xBackendVariant }),
      ...config.headers,
    },
  };
});
